// extracted by mini-css-extract-plugin
export default {"description":"Description_description__rv3HE","content":"Description_content__agyFu","truncated":"Description_truncated__AFtlT","more":"Description_more__WGGCL"};